import { rootRoute } from './root-route';
import { authenticatedRoute } from './authenticated-route';
import { homeRoute } from '@/routes/home.routes';
import { companyCreateRoute } from '@/routes/company-create.routes';
import { companyCreateSuccessRoute } from '@/routes/company-create-success.routes';
import { companyEditRoute, companyEditSuccessRoute } from '@/routes/company-edit.routes';
import { candidateProfileRoute } from '@/routes/candidate-profile.routes';
import {
  candidateAttestationViewerRoute,
  candidateResumeViewerRoute,
} from '@/routes/candidate-document.routes';

import { jobsRoute } from '@/routes/jobs-list.routes';
import { jobCreateRoute } from '@/routes/job-create.routes';
import { jobCreateSuccessRoute } from '@/routes/job-create-success.routes';
import { jobManagementRoute } from '@/routes/job-management.routes';
import {
  jobMoveCandidatesRoute,
  jobRejectCandidatesRoute,
} from '@/routes/job-bulk-candidates.routes';
import { jobEditRedirectRoute } from '@/routes/job-edit-redirect.routes';
import { jobEditInfoRoute } from '@/routes/job-edit-info.routes';
import { jobEditWorkAreasRoute } from '@/routes/job-edit-work-areas.routes';
import { jobEditConditionsRoute } from '@/routes/job-edit-conditions.routes';
import { jobEditCompensationRoute } from '@/routes/job-edit-compensation.routes';
import { jobEditGraduationRoute } from '@/routes/job-edit-graduation.routes';
import { jobEditCoursesRoute } from '@/routes/job-edit-courses.routes';
import { jobEditRequirementsRoute } from '@/routes/job-edit-requirements.routes';
import { jobEditFaqsRoute } from '@/routes/job-edit-faqs.routes';
import { jobFlowRoute } from '@/routes/job-flow.routes';
import { formCreateRoute, formEditRoute, formsListRoute } from '@/routes/forms.routes';
import { programsRoute } from '@/routes/programs.routes';
import { programManagementRoute } from '@/routes/program-management.routes';
import { programAlignmentFormEditRoute } from '@/routes/program-alignment-form.routes';
import { programCreateRoute } from '@/routes/program-create.routes';
import { programCreateBenefitsRoute } from '@/routes/program-create-benefits.routes';
import { programCreateFaqsRoute } from '@/routes/program-create-faqs.routes';
import { programCreateSuccessRoute } from '@/routes/program-create-success.routes';
import { programEditRoute } from '@/routes/program-edit.routes';
import { programEditBenefitsRoute } from '@/routes/program-edit-benefits.routes';
import { programEditFaqsRoute } from '@/routes/program-edit-faqs.routes';
import { programEditSuccessRoute } from '@/routes/program-edit-success.routes';

import { okrsRoute } from '@/routes/okrs.routes';

import { loginRoute } from '@/routes/login.routes';
import { sharedDocumentRoute } from '@/routes/shared-document.routes';
import { jobDescriptionRoutes } from '@/routes/job-description.routes';

export const routeTree = rootRoute.addChildren([
  loginRoute,
  // Pública (EU-594): visualização externa de documento compartilhado — fica
  // FORA do authenticatedRoute (usuário anônimo, sem workspace).
  sharedDocumentRoute,
  // Pública (DEV-258): formulário da pessoa gestora, aberto por link + token.
  ...jobDescriptionRoutes,
  authenticatedRoute.addChildren([
    homeRoute,
    companyCreateRoute,
    companyCreateSuccessRoute,
    companyEditRoute,
    companyEditSuccessRoute,
    candidateProfileRoute,
    candidateResumeViewerRoute,
    candidateAttestationViewerRoute,
    programsRoute,
    programManagementRoute,
    programAlignmentFormEditRoute,
    jobsRoute,
    jobCreateRoute,
    jobCreateSuccessRoute,
    jobManagementRoute,
    jobMoveCandidatesRoute,
    jobRejectCandidatesRoute,
    jobEditRedirectRoute,
    jobEditInfoRoute,
    jobEditWorkAreasRoute,
    jobEditConditionsRoute,
    jobEditCompensationRoute,
    jobEditGraduationRoute,
    jobEditCoursesRoute,
    jobEditRequirementsRoute,
    jobEditFaqsRoute,
    jobFlowRoute,
    formsListRoute,
    formCreateRoute,
    formEditRoute,
    programCreateRoute,
    programCreateBenefitsRoute,
    programCreateFaqsRoute,
    programCreateSuccessRoute,
    programEditRoute,
    programEditBenefitsRoute,
    programEditFaqsRoute,
    programEditSuccessRoute,
    // EU-756 — App de OKRs. Sem link na navegacao: acesso so por link direto.
    okrsRoute,
  ]),
]);
